import React from 'react';
import md5Hex from 'md5-hex';
import Identicon from 'identicon.js';

// Utility function to convert hex color to RGBA array
function hexToRGBA(hex) {
  // Remove '#' if present
  hex = hex.replace('#', '');
  // Parse hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Return RGBA array with full opacity (255)
  return [r, g, b, 255];
}

function Avatar(props) {
    let hex = md5Hex(props.value);
    // Convert hex color to RGBA if provided, else default to black
    const foregroundColor = props.color ? hexToRGBA(props.color) : [0, 0, 0, 255];
    let options = {
        foreground: foregroundColor, // Use converted color or default
        background: [255, 255, 255, 255], // Fixed white background
        size: 80
    };
    let data = new Identicon(hex, options).toString();
    return <img src={"data:image/png;base64," + data} alt="Profile" className="img-fluid rounded-circle mr-2" style={{height:"50px"}}/>
}

export default Avatar;